module.exports = __webpack_public_path__ + "img/wf.e3ac728c.svg";